import { _ as r } from "./index837.mjs";
var a = r, o = a.Uint8Array, i = o;
export {
  i as _
};
